import { render, staticRenderFns } from "./CommonSettingsBlock.vue?vue&type=template&id=61aa0c4e&scoped=true"
import script from "./CommonSettingsBlock.vue?vue&type=script&lang=js"
export * from "./CommonSettingsBlock.vue?vue&type=script&lang=js"
import style0 from "./CommonSettingsBlock.vue?vue&type=style&index=0&id=61aa0c4e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aa0c4e",
  null
  
)

export default component.exports